import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { BusinessItemsQueryParams, PendingQueryParams } from '../schemas/business-item'

/**
 * Query keys for business items
 */
export const business = createQueryKeys('business', {
  list: (params?: BusinessItemsQueryParams) => [{ params }],
  pending: (params?: PendingQueryParams) => [{ params }],
  detail: (businessId: number) => [{ businessId }],
})
